import React, { useEffect, useState } from "react";
import "../../views/styles.css";
import "bootstrap/dist/css/bootstrap.css";
import "./modal.css"
// import ReactDragListView from 'react-drag-listview';
import "font-awesome/css/font-awesome.min.css";
import FadeIn from "react-fade-in";
import { useLoading, Rings } from "@agney/react-loading";
function Stage({ title, body, handleSave, show, handleClose , showFooter}) {

    return (
        <>

            <div
                className="modal fadeIn"
                style={{ display: "block", zIndex: 9999 ,
                alignItems : 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(0,0,0,0.3)',
            
               }}
                role="dialog"
                id="kwModal"

            >
                {/* modal start */}

                <FadeIn>
                    <div className="modal-dialog modal-dialog-centered kw-workflow-modal" role="document" style={{justifyContent: 'center', paddingTop:'4%'}}>
                        <div className="cmodal modal-content" style={{maxWidth: "600px" , minHeight:'100px' ,
                            borderRadius: '12px' , borderWidth:0
                    }}>
                            <div className="m-header"> 
                                <span>{title}</span>
                                <span style={{ cursor: 'pointer' }} onClick={handleClose} >x</span>
                            </div>

                            {body}

  
                            <div className="m-footer">
                                <input
                                    type="submit"
                                    name="Save"
                                    style={{ margin_top: "2v", cursor: "pointer" }}
                                    className="add lg_btn primary"
                                    value="Save"
                                    onClick={() => { handleSave() }}
                                />
                                <span className="ml-5"></span>
                                <input
                                    type="submit"
                                    name="Cancel"
                                    style={{ margin_top: "2v", cursor: "pointer", marginLeft: '22px' }}
                                    className="ml-22 add lg_btn tertiary"
                                    value="Cancel"
                                    onClick={handleClose}
                                />
                            </div>
                        </div>
                    </div>
                </FadeIn>
            </div>



        </>
    );
}
export default Stage;

